import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addBnpi = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(`/api/resource/bnpl`, body);
  return data;
});
export const updateBnpi = catchAsync(async (body, editId) => {
  const { data } = await axiosInstance.put(
    `/api/resource/bnpl/${editId}`,
    body
  );
  return data;
});

export const getIBnpi = catchAsync(async (lang) => {
  const { data } = await axiosInstance.get(
    // `/api/resource/bnpl?fields=["name","name1","custom_account"]`
    `/api/resource/bnpl?fields=["name","name1","custom_account","custom_plus_riyal","custom_percentage"]`
  );
  return data;
});
export const getIBnpiDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/bnpl/${id}`);
  return data;
});
export const deleteBnpi = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(`/api/resource/bnpl/${id}`);
  return data;
});
